import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { usePbm2Url } from "@common/hooks/usePbm2Url";
import { IProductbyPrograms } from "../contracts";
import { CursorPaginated } from "@types";

export interface ProductsArgsFilterInput {
  programCode?: string;
}

export interface UseProductsOptions {
  limit?: number;
  filter?: ProductsArgsFilterInput;
}

export function useProducts(programCode: string, options: UseProductsOptions | undefined = {}) {
  const { request } = usePbm2Url();
  options.filter = programCode ? { programCode } : { programCode: "" }

  return useQuery(`refund_program_products:${programCode}`, async () => {
    const { Refund_products } = await request(
      gql`
      query Refund_products(
        $before: String
        $after: String
        $first: Int
        $last: Int
        $filter: Refund_ProductsArgsFilterInput
      ) {
        Refund_products(
          before: $before
          after: $after
          first: $first
          last: $last
          filter: $filter
        ) {
          edges {
            cursor
            node {
              id
              name
              description
              productType
              contentType
              contentQuantity
              controlled
              createdAt
              updatedAt
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            pageCount
            totalCount
          }
        }
      }      
    `,
      options
    );
    return Refund_products as CursorPaginated<IProductbyPrograms>;
  });
}

